<template>
  <div style="height: 100%">
    <grid
      ref="grid"
      :config="gridConfig"
      class="no-grid-border"
      @handleCustomButtonGrid="handlerQuickRFQ"
    >
      <template  v-slot:column-control-left="{ row }">
        <li>
          <el-button style="line-height: 1;" size="mini" @click="copyStock({ row })" type="info" icon="el-icon-copy-document">
            {{L10n('copy-to-clipboard')}}
          </el-button>
        </li>
      </template>
    </grid>
    <editor-wrap
      :disabled="isDisabledForm"
      :onQuickRFQ="handlerQuickRFQ"
    />
    <dialog-confirm
      :isVisible="isVisibleConfirm"
      :statusID="statusID"
      @onCancel="handleCancel"
      @onConfirm="handleConfirm"
    />
  </div>
</template>

<script>
import gridConfig from './GridConfig.js'
import { waitValue } from '@/utils/promises'
import { ServiceStocks } from '@/services/Stocks'

export default {
  name: 'StocksParts',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor-wrap': () => import(/* webpackChunkName: 'Parts' */ './editor-wrap.vue'),
    'dialog-confirm': () => import(/* webpackChunkName: 'Parts' */ './DialogConfirm')
  },
  props: {
    partID: { required: true }
  },
  data () {
    return {
      statusID: null,
      stockID: null
    }
  },
  watch: {
    'partID': {
      immediate: true,
      handler () {
        this.getGrid()
          .then((grid) => {
            if (this.partID) {
              grid.setFilters(`partID == ${this.partID}`)
              grid.loadData()
            }
          })
      }
    }
  },
  computed: {
    isDisabledForm () {
      return !this.permission(this.$store.getters.get('permissions'), 'isAllowToEditStocks')
    },
    gridConfig () {
      return gridConfig({ fnClassButton: this.classButton })
    },
    isVisibleConfirm () {
      return !!(this.statusID && this.stockID)
    }
  },
  methods: {
    isConfirm (row) {
      return row.statusID !== 1
    },
    classButton (row) {
      return {
        'btn-red btn-red__important': this.isConfirm(row)
      }
    },
    getGrid () {
      return waitValue(() => this.$refs.grid)
    },
    handlerQuickRFQ ({ row }) {
      if (this.isConfirm(row)) {
        this.stockID = row.id
        this.statusID = row.statusID
      } else {
        this.handleConfirm({ stockID: row.id })
      }
    },
    handleCancel () {
      this.stockID = null
      this.statusID = null
    },
    handleConfirm ({ stockID }) {
      this.$emit('on-quick-rfq', { stockID })
      this.stockID = null
      this.statusID = null
    },
    makeClipboardText ({ row }) {
      return ServiceStocks.makeStockTextInfo(row)
    },
    async copyToClipboard (text) {
      if (!text) {
        return
      }

      try {
        await navigator.clipboard.writeText(text)

        this.$notify.success({
          title: this.L10n('success'),
          message: this.L10n('copied-to-clipboard')
        })
      } catch {
        this.$notify.error({
          title: this.L10n('error'),
          message: this.L10n('failed-to-copy')
        })
      }
    },
    copyStock ({ row }) {
      const res = this.makeClipboardText({ row })
      this.copyToClipboard(res)
    }
  }
}
</script>
